import CredentialFormBase from "./credential_form_base"

// Dedicated to the cloud storage dialog (_storage_modal.html.erb) — one dialog, a provider tab
// strip (S3 / GCS / Azure), and only that provider's fields and "where to find these" box.
export default class extends CredentialFormBase {
  static targets = ["sourceType", "heading", "tab", "s3Section", "gcsSection", "azureSection"]

  connect() {
    this.updateProvider()
    this.openDialog()
  }

  selectProvider(event) {
    this.sourceTypeTarget.value = event.currentTarget.dataset.provider
    this.updateProvider()
  }

  updateProvider() {
    const provider = this.sourceTypeTarget.value
    const selectedTab = this.tabTargets.find(tab => tab.dataset.provider === provider)
    if (this.hasHeadingTarget && selectedTab) this.headingTarget.textContent = `Connect ${selectedTab.dataset.providerName}`
    for (const [name, sections] of Object.entries({ s3: this.s3SectionTargets, gcs: this.gcsSectionTargets, azure: this.azureSectionTargets })) {
      sections.forEach(section => this.toggleSection(section, provider === name))
    }
    this.tabTargets.forEach(tab => this.markChoice(tab, tab.dataset.provider === provider))
  }
}
